import { render, staticRenderFns } from "./RegistrationReportFilterPrimary.vue?vue&type=template&id=17a981a4"
import script from "./RegistrationReportFilterPrimary.vue?vue&type=script&lang=js"
export * from "./RegistrationReportFilterPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports